import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth/auth-guard';
import { LoginGuard } from './core/guards/login/login-guard';
// import { ErrorComponent } from './shared/components/error/error';
export const routes: Routes = [
  /* =========================================
     DEFAULT REDIRECT
  ========================================= */

  {
    path: '',

    redirectTo: 'login',

    pathMatch: 'full',
  },

  /* =========================================
     ERROR PAGE
  ========================================= */

  //   {
  //   path: 'feedback/:device_uid',

  //   loadComponent: () =>
  //     import('./pages/admin/devices-management/feedback/feedback')
  //       .then((m) => m.Feedback),

  //   data: {
  //     fullscreen: true,
  //   },
  // },

  //   {
  //     path: 'qr-print/:id',
  //     loadComponent: () => import('./qr-print/qr-print').then((m) => m.QrPrint),
  //   },

  //   {
  //   path: 'user-manual',

  //   loadComponent: () =>
  //     import('./user-manual/user-manual')
  //       .then((m) => m.UserManual),

  //   data: {
  //     fullscreen: true,
  //   },
  // },

  //   {
  //     path: 'error',

  //     component: ErrorComponent,
  //   },

  /* =========================================
     AUTH ROUTES
  ========================================= */

  {
    path: '',

    canActivate: [LoginGuard],

    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },

  /* =========================================
   ADMIN PANEL
========================================= */

  {
    path: '',

    loadComponent: () => import('./layout/main-layout/main-layout').then((m) => m.MainLayout),

    canActivate: [AuthGuard],

    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.routes').then((m) => m.PAGES_ROUTES),
      },
    ],
  },
  /* =========================================
   USER PANEL
========================================= */

  //   {
  //     path: 'user',

  //     component: MainLayout,

  //     canActivate: [AuthGuard],
  //     children: [
  //       {
  //         path: '',

  //         loadChildren: () => import('./pages/user/user.routes').then((m) => m.USER_ROUTES),
  //       },
  //     ],
  //   },
  {
    path: 'error',
    loadComponent: () => import('./shared/components/error/error').then((m) => m.ErrorComponent),
    title: 'Error',
  },
  {
    path: '**',
    loadComponent: () => import('./shared/components/error/error').then((m) => m.ErrorComponent),
    title: 'Page Not Found',
  },
];
